module.exports = __webpack_public_path__ + "img/worksandwriters.3c16d623.png";